export const COLOR = {
  PRIMARY: '#178fe3',
  PRIMARY_HOVER: '#178fe3',
  SECONDARY: '#47E5BC',
  SECONDARY_HOVER: '#47c9a7',
  DANGER: '#e82525',
  DANGER_HOVER: '#f74a4a',
  SUCCESS: '#1dd153',
  SUCCESS_HOVER: '#16b847',
  PRIMARY_DARKER: '#14517c',
  TEXT_DESCRIPTIVE: 'rgb(184,184,184)',
  INPUT_DISABLED: 'rgb(240,240,240)',
  BORDER: '#DDD',
  BUTTON_TEXT: '#121212',
  BUTTON_FACE: '#FAFAFA',
  BUTTON_FACE_HOVER: '#EDEDED',
  DANGER_BORDER: '#ff9090',
  DANGER_INPUT_BACKGROUND: '#FFEFEF'
}
export const COLOR_PRIMARY = '#00ad8c';
export const COLOR_SECONDARY = '#47E5BC';
export const COLOR_PRIMARY_DARKER = '#14517c';
export const COLOR_DESCRIPTIVE_TEXT = '#B9B9B9';
export const COLOR_TEXT_DEFAULT = 'rgb(50,50,50)';
export const COLOR_TEXT_GREY = 'rgb(184,184,184)';
export const COLOR_DANGER = 'red';
export const COLOR_DANGER_BORDER = '#ff9090';
export const COLOR_DANGER_INPUT_BACKGROUND = '#ffefef';
export const COLOR_SIDEBAR = 'rgb(30,30,45)';